const modul = {
	namespaced: true,

	state: {
		oanvandaVisas: false,	// = initialt defaultvärde

		rullningsbaraElement: [ 	// = initiala defaultvärden
			{ id:'re1', scrollTop: 0 },
		],
	},

	mutations: {

		setOanvandaVisas(state, nyttVarde)
		{
			// `state` is the local module state
			state.oanvandaVisas = nyttVarde;
		},

		// rullningsbaraElement muteras via en "root mutation" som används av flera modules/namespaces:
	},

	//actions: { ... },

	//getters: { ... }
};

export { modul as ssoStatestoreKontoplan }
